var path = '/pages/contacts/directives/sections/documents/contact-documents.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/directives/sections/documents/contact-documents.tpl.html
// module id = 2219
// module chunks = 1